import React from 'react';
import styled from 'styled-components';
import Loader from '../atoms/Loader';

const Wrapper = styled.div`
  position: relative;
`;

const Overlay = styled.div<{ isLoading: boolean }>`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: ${(props) => (props.isLoading ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const OverlayLoader = ({
  isLoading,
  children,
}: React.PropsWithChildren<{ isLoading: boolean }>) => (
  <Wrapper>
    <Overlay isLoading={isLoading}>
      <Loader type="Oval" width={50} height={50} />
    </Overlay>
    {children}
  </Wrapper>
);

export default OverlayLoader;
